import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProjectCard = ({ title, des, src }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/gallery');
  };

  return (
    <div
      onClick={handleClick}
      className="w-full p-4 xl:px-12 h-auto xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000 cursor-pointer"
    >
      {/* Image Container */}
      <div className="w-full aspect-video bg-black rounded-lg overflow-hidden flex justify-center items-center">
        <img
          className="w-full h-full object-contain"
          src={src}
          alt="project"
        />
      </div>

      {/* Text Content */}
      <div className="w-full mt-5 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h3 className="text-base uppercase text-designColor font-normal">
            {title}
          </h3>
        </div>
        <p className="text-sm tracking-wide hover:text-gray-100 duration-300 text-gray-300">
          {des}
        </p>
      </div>
    </div>
  );
};

export default ProjectCard;
